// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3KBoa","rootSmall":"AddTileButton_rootSmall__icb4t"};